<template>
  <div style="border:1px dashed #A9A9A9;margin-top:4px;padding:8px 8px">
    <el-row>
      <el-col :span="4">
        <label>{{ evalName }}</label>
      </el-col>
      <el-col :span="20">
        <el-checkbox-group v-model="valueSelectList" v-if="choiceType === 2">
          <el-checkbox
            v-for="item in evalValueArray"
            :label="item.id"
            :key="item.id"
            :checked="item.selected"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
        <el-radio-group v-model="valueSelectList" v-else>
          <el-radio
            border
            v-for="item in evalValueArray"
            :label="item.id"
            :key="item.id"
            :checked="item.selected"
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "evalModelValueOption",
  components: {},
  props: ["index", "type", "evalValueObject"],
  data() {
    return {
      evalName: "",
      evalValueArray: [],
      valueSelectList: [],
      choiceType: 1,
    };
  },
  watch: {
    valueSelectList: "getSelectValue",
  },
  computed: {},
  methods: {
    getSelectValue() {
      if (this.choiceType === 2) {
        this.$props.evalValueObject.selected = this.valueSelectList.length > 0;
        this.evalValueArray.forEach((e) => {
          if (this.valueSelectList.findIndex((item) => item === e.id) === -1) {
            e.selected = false;
          } else {
            e.selected = true;
          }
        });
      } else {
        this.$props.evalValueObject.selected = this.valueSelectList > 0;
        this.evalValueArray.forEach(e=>{
          if(e.id===this.valueSelectList){
            e.selected = true;
          }else{
            e.selected = false;
          }
        })
      }

      this.$emit(
        "getCildrenValue",
        this.$props.index,
        this.$props.type,
        this.$props.evalValueObject
      );
    },
  },
  created() {},
  mounted() {
    let _self = this;
    this.evalName = this.$props.evalValueObject.name;
    this.choiceType = this.$props.evalValueObject.multipleChoice;
    this.evalValueArray = this.$props.evalValueObject.children;
    this.evalValueArray.forEach(e=>{
            if(e.isGood==1){
              if(_self.choiceType==2){
                _self.valueSelectList.push(e.id)
            }else{
              _self.valueSelectList = e.id
            }
    }})
  },
};
</script>
<style lang="less" scoped></style>
